export default "__VITE_ASSET__DUyKOWnr__"